// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__F1sxj","hero-content":"Hero_hero-content__cZ8Yx","hero-image-wrapper":"Hero_hero-image-wrapper__QuiBV","hero-image":"Hero_hero-image__JvY9w"};